import { feature as NotificationOrchestratorFeature } from '@central-products/notification-orchestrator';

export const notificationOrchestratorPlugin = {
  beforeBootstrap({ addBootstrapperFeature, params }) {
    addBootstrapperFeature(NotificationOrchestratorFeature, params);
  },
};
